export default __webpack_public_path__ + "static/media/Close_Icon_2.65185197.svg";